export default __webpack_public_path__ + "static/media/img5.27ae5ecf.png";